import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const EditVendor = () => {
  const { id } = useParams(); // Get vendor ID from URL params
  const navigate = useNavigate();

  // State for vendor data and loading state
  const [vendor, setVendor] = useState({
    gst_no: '',
    name: '',
    print_name: '',
    identification: '',
    code: '',
    contact: '',
    gst: '',
    registration_date: '',
    cin: '',
    pan: '',
    gst_category: '',
    gst_suspend: '',
    distance: '',
    tds_on_gst: '',
    address: '',
    country: '',
    state: '',
    city: '',
    pin_code: '',
    phone: '',
    email: '',
    longitude: '',
    latitude: '',
    website: '',
    facebook: '',
    skype: '',
    twitter: '',
    linkedin: '',
    payment_term: '',
    price_category: '',
    agent_broker: '',
    transporter: '',
    credit_limit: '',
    max_credit_days: '',
    interest_rate_yearly: '',
    lfsc_rtgs_code: '',
    account_number: '',
    bank_name: '',
    branch: '',
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch vendor data on component mount
  useEffect(() => {
    setLoading(true);
    fetch(`http://localhost:8000/api/vendors/${id}`)
      .then((response) => response.json())
      .then((data) => {
        setVendor(data); // Populate the form with existing vendor data
      })
      .catch((err) => {
        setError('Failed to load vendor data');
      })
      .finally(() => setLoading(false));
  }, [id]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setVendor((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    // Update vendor data using PUT request
    fetch(`http://localhost:8000/api/vendors/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(vendor),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 'success') {
          alert('Vendor updated successfully');
          navigate('/vendor-list'); // Redirect to Vendor List after successful update
        } else {
          throw new Error('Failed to update vendor');
        }
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  };

  return (
    <div id="main">
      <header className="mb-3">
        <a href="#" className="burger-btn d-block d-xl-none">
          <i className="bi bi-justify fs-3"></i>
        </a>
      </header>

      <div className="page-heading">
        <div className="page-title">
          <div className="row">
            <div className="col-12 col-md-6 order-md-1 order-last">
              <h3>Edit Vendor</h3>
              <p className="text-subtitle text-muted">Edit vendor details</p>
            </div>
            <div className="col-12 col-md-6 order-md-2 order-first">
              <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Dashboard</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Edit Vendor
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Edit Vendor</h4>
              </div>
              <div className="card-body">
                {loading ? (
                  <p>Loading...</p>
                ) : (
                  <form onSubmit={handleSubmit}>
                    {Object.keys(vendor).map((field) => (
                      <div className="mb-3" key={field}>
                        <label htmlFor={field} className="form-label">
                          {field.replace(/_/g, ' ').toUpperCase()}
                        </label>
                        {field === 'registration_date' ? (
                          <input
                            type="date"
                            className="form-control"
                            id={field}
                            name={field}
                            value={vendor[field] || ''}
                            onChange={handleChange}
                          />
                        ) : field === 'email' ? (
                          <input
                            type="email"
                            className="form-control"
                            id={field}
                            name={field}
                            value={vendor[field] || ''}
                            onChange={handleChange}
                          />
                        ) : (
                          <input
                            type="text"
                            className="form-control"
                            id={field}
                            name={field}
                            value={vendor[field] || ''}
                            onChange={handleChange}
                          />
                        )}
                      </div>
                    ))}
                    <button type="submit" className="btn btn-primary" disabled={loading}>
                      {loading ? 'Updating Vendor...' : 'Update Vendor'}
                    </button>
                    {error && <p className="text-danger">{error}</p>}
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EditVendor;
